import * as React from "react";
import { ContainerFull, FullWidthForm, } from "../../../components/Styles/Styles";
import Button from "../../../components/connect-ui/Button";
import Header from "../../../components/Header";
import IssuerHeader from "../../../components/IssuerHeader";
import RouteHeaderLogo from "../../../components/RouteHeaderLogo";
import { Transition } from "@headlessui/react";
import classNames from "classnames";
import useCloseClickHandler from "../../../hooks/useCloseClickHandler";
export default function AuthCompleteRouteBase() {
    var closeClickHandler = useCloseClickHandler();
    var _a = React.useState(false), show = _a[0], setShow = _a[1];
    function handleClose(event) {
        event.preventDefault();
        closeClickHandler();
    }
    React.useEffect(function () {
        setTimeout(function () { return setShow(true); }, 250);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(ContainerFull, null,
            React.createElement(IssuerHeader, null),
            React.createElement(FullWidthForm, { className: "justify-center pb-[112px]" },
                React.createElement(Transition, { className: "flex w-full flex-col items-center font-bold", enter: "transition-all duration-[350ms]", enterFrom: "opacity-0 -translate-y-12", enterTo: "opacity-100 translate-y-0", leave: "transition-opacity duration-150", leaveFrom: "opacity-100", leaveTo: "opacity-0", appear: true, show: show },
                    React.createElement("img", { src: "".concat(process.env.ASSET_PATH, "assets/images/check.png"), alt: "Green checkmark", loading: "lazy", className: "mb-4 h-20" }),
                    React.createElement("h2", { className: classNames("text-2xl font-bold"), id: "login-successful" }, "Login Successful"),
                    React.createElement(Button, { id: "login-continue", className: "mt-6", onClick: handleClose, type: "submit" }, "Continue"))))));
}
